import axios from 'axios'
import { useAuthStore } from '../store/auth'
import { handleLogout } from '../utils/utils'

const { REACT_APP_API_LOCAL } = process.env

export const api = axios.create({
  baseURL: REACT_APP_API_LOCAL,
  headers: {
    Accept: 'application/json', 
  },
})

api.interceptors.request.use(
  async (config) => {
    const token = useAuthStore.getState().token
    if (token) {
      config.headers.set('Authorization', `Bearer ${token}`)
    } else {
      config.headers.delete('Authorization')
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error?.response?.status === 401) {
      handleLogout()
    } else if (error?.response?.status === 403) {
      if (error?.response?.data?.errors === 'Conta de usuário desativada.') {
        handleLogout()
      }
    }
    return Promise.reject(error)
  },
)
